export const valueCanNotBeFalsyError = new Error('ERROR: value can not be falsy');
